import React from "react";
import { PageNewState, componentEditDialogInitialState } from ".";

export const ComponentEditDialogContext = React.createContext({
  pageState: componentEditDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
